import {StateProvider} from "@uirouter/angularjs";
import {UserConfigProvider} from "../../types/UserConfig";
import {RiskService} from "./service/RiskService";
import {SystemEventService} from "../../services/system-state/SystemEventService";
import {RiskDashboardViewStore} from "./store/RiskDashboardViewStore";
import {ClientEventService} from "../../services/client-events/ClientEventService";
import {AnalyticsService} from "../../analytics/services/AnalyticsService";
import {AnalyticsType} from "../../analytics/models/AnalyticsType";

/** @ngInject */
export function routerConfig($stateProvider: StateProvider,
                             userConfigProvider: UserConfigProvider) {

    $stateProvider.state("risk-dashboard", {
        url: "/risk-dashboard",
        component: "riskDashboard",
        data: {
            pageTitle: "Risk Dashboard"
        },
        resolve: {
            viewStore: viewStoreResolver
        },
        /** @ngInject */
        onEnter: (analyticsService: AnalyticsService) => {
            analyticsService.submit(AnalyticsType.VISIT_CLEARING_DASHBOARD);
            return userConfigProvider.config.features["CLEARING_DASHBOARD"];
        },
        onExit: cleanUpTask
    });
}

/** @ngInject */
export function viewStoreResolver(riskService: RiskService,
                                  systemEventService: SystemEventService,
                                  clientEventService: ClientEventService): RiskDashboardViewStore {
    return new RiskDashboardViewStore(riskService, systemEventService, clientEventService);
}

/** @ngInject */
export function cleanUpTask(viewStore: RiskDashboardViewStore) {
    viewStore.destroy();
}
